module.exports = __webpack_public_path__ + "img/PictureButton.1800b482.svg";